import { DefinedPropertyObject, ISearchTermParametersDefaults } from "../../api/GenericTypes";
import { Project, ProjectFilters } from "../../api/Projects";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { EntityFilterSideBar } from "../../common/sidebar/filtersidebar/EntityFilterBar";
import { CustomTypesVirtualizedSelectForm } from "../../common/forms/EntityForms/formsVirtualized/CustomTypesVirtualizedSelectForm";
import {
  CustomFieldFilterLayout,
  CustomFieldFilterLayoutForm,
} from "../../Customization/CustomFieldFilters/CustomFieldFilterLayout/CustomFieldFilterLayout";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import { CombinedModificationRecordEntityFilterForm } from "../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";
import { FoldableFilters } from "../../common/sidebar/filtersidebar/GenericFilters/common/FoldableFilters";

export interface ProjectFilterForm extends ICombinedModificationRecordEntityForm, CustomFieldFilterLayoutForm {
  customType?: { id: number; name: string }[] | undefined | null;
}

const defaultValues: DefinedPropertyObject<ProjectFilterForm> = {
  customType: null,
  ...CombinedModificationRecordEntityDefaultFormValues,
  customFieldFilters: [],
};
export const projectsFormToFilters = (form: ProjectFilterForm): ProjectFilters => {
  let filters: ProjectFilters = {
    ...combinedModificationRecordEntityFormToFilters(form),
  };
  filters.customTypeIds =
    Array.isArray(form.customType) && form.customType.length > 0 ? form.customType.map((d) => d.id) : null;
  return filters;
};
/**
 * Converts ProjectFilters to ProjectFilterForm
 * @param filters ProjectFilters
 * @returns ProjectFilterForm
 * @author @CorradoSurmanowicz
 */
export const filtersToProjectsForm = (filters: ProjectFilters): ProjectFilterForm => {
  return {
    customType: filters.customTypeIds ? filters.customTypeIds.map((id) => ({ id, name: "" })) : null,
    ...combinedModificationRecordEntityFiltersToForm(filters),
  };
};
const defaultFilters: ProjectFilters = {
  sortBy: [{ property: "NAME", sortDirection: "ASC" }],
  ...ISearchTermParametersDefaults,
};

export const ProjectFilterBar = ({
  initialValues,
  onFormChange,
  dispatchTabStore,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<Project, ProjectFilterForm, ProjectFilters>) => {
  // const stateArray = [!!initialValues?.customType];

  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultFilters}
      formToFilters={projectsFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
      customTypeConstraint="Project"
    >
      {({ control, errors, onReset, customFieldsDict }) => (
        <EntityFilterSideBar onReset={onReset}>
          <FoldableFilters
            label="General"
            // defaultOpen={stateArray.some((p) => p) && !!stateArray.length}
            defaultOpen
          >
            <CustomTypesVirtualizedSelectForm
              id="customType"
              label="Project types"
              control={control}
              showControls={false}
              filters={{ entityTypes: ["Project"] }}
              isMulti
              enableBasicOption
              hideIfNoTypes
            />
          </FoldableFilters>

          {customFieldsDict && (
            <CustomFieldFilterLayout
              control={control}
              errors={errors}
              customFieldsDict={customFieldsDict}
              entityTypes={["Project"]}
            />
          )}

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
